const $27ae042fb67f0155$var$ID_SELECTOR = "input[data-tracking-id]";
const $27ae042fb67f0155$var$ID_PARAM = "dtid";
const $27ae042fb67f0155$var$ID_STORAGE = "tracking__dtid";
function $27ae042fb67f0155$export$56042744dfb7b649(document) {
    const trackingId = $27ae042fb67f0155$var$retrieveTrackingId(document);
    if (!trackingId) return;
    const inputs = document.querySelectorAll($27ae042fb67f0155$var$ID_SELECTOR);
    inputs.forEach((input)=>input.value = trackingId);
}
function $27ae042fb67f0155$var$retrieveTrackingId(document) {
    const searchParams = new URLSearchParams(document.location.search);
    if (searchParams.has($27ae042fb67f0155$var$ID_PARAM)) {
        sessionStorage.setItem($27ae042fb67f0155$var$ID_STORAGE, searchParams.get($27ae042fb67f0155$var$ID_PARAM));
        return searchParams.get($27ae042fb67f0155$var$ID_PARAM);
    } else if (sessionStorage.getItem($27ae042fb67f0155$var$ID_STORAGE)) return sessionStorage.getItem($27ae042fb67f0155$var$ID_STORAGE);
    else return null;
}


const $a9391f36ee1dd78b$var$SELECTOR = "[data-webhook-form]";
const $a9391f36ee1dd78b$var$WEBBOOK_URL_ATTRIBUTE = "data-webhook-url";
const $a9391f36ee1dd78b$var$REDIRECT_URL_ATTRIBUTE = "data-redirect-url";
const $a9391f36ee1dd78b$var$LOADING_SELECTOR = "[data-webhook-loading]";
const $a9391f36ee1dd78b$var$ERROR_SELECTOR = "[data-webhook-error]";
const $a9391f36ee1dd78b$var$SUCCESS_SELECTOR = "[data-webhook-success]";
const $a9391f36ee1dd78b$var$INFO_SELECTOR = "[data-webhook-info]";
function $a9391f36ee1dd78b$export$1c0a72bcebfd0fb0(document) {
    const forms = document.querySelectorAll($a9391f36ee1dd78b$var$SELECTOR);
    forms.forEach((form)=>form.addEventListener("submit", handle));
    function handle(event) {
        event.preventDefault();
        const form = event.target;
        const submitter = event.submitter;
        const loading = form.querySelector($a9391f36ee1dd78b$var$LOADING_SELECTOR);
        const error = form.querySelector($a9391f36ee1dd78b$var$ERROR_SELECTOR);
        const success = form.querySelector($a9391f36ee1dd78b$var$SUCCESS_SELECTOR);
        const info = form.querySelector($a9391f36ee1dd78b$var$INFO_SELECTOR);
        const webhookUrl = form.getAttribute($a9391f36ee1dd78b$var$WEBBOOK_URL_ATTRIBUTE);
        const redirectUrl = form.getAttribute($a9391f36ee1dd78b$var$REDIRECT_URL_ATTRIBUTE);
        const data = new FormData(form);
        error && (error.style.display = "none");
        success && (success.style.display = "none");
        info && (info.style.display = "none");
        loading && (loading.style.display = "block");
        submitter.disabled = true;
        fetch(webhookUrl, {
            method: "POST",
            body: data
        }).catch((error)=>{
            console.error(error);
            return {
                ok: false
            };
        }).then((res)=>{
            if (res.ok && redirectUrl) setTimeout(()=>{
                form.reset();
                loading && (loading.style.display = "none");
                info && (info.style.display = "block");
                submitter.disabled = false;
                document.location.href = redirectUrl;
            }, 100);
            else if (res.ok) {
                form.reset();
                loading && (loading.style.display = "none");
                success && (success.style.display = "block");
                submitter.disabled = false;
            } else {
                loading && (loading.style.display = "none");
                error && (error.style.display = "block");
                submitter.disabled = false;
            }
        });
    }
}


function $7959764b0a625ff0$export$a973cef5093a8d22(document) {
    const SELECTOR = "[data-infinite-scroll]";
    const containers = document.querySelectorAll(SELECTOR);
    containers.forEach($7959764b0a625ff0$var$cloneContainer);
}
function $7959764b0a625ff0$var$cloneContainer(container) {
    const clone = container.cloneNode(true);
    container.parentNode.appendChild(clone);
}


(0, $27ae042fb67f0155$export$56042744dfb7b649)(document);
(0, $a9391f36ee1dd78b$export$1c0a72bcebfd0fb0)(document);
(0, $7959764b0a625ff0$export$a973cef5093a8d22)(document);


//# sourceMappingURL=index.ff9cfc44.js.map
